import {Input, TextBox} from "@progress/kendo-react-inputs";
import {DropDownList} from "@progress/kendo-react-dropdowns";

const InvoiceBasicParams = props => {



    const tags = props.tags
    const setTags = props.setTags
    const invoiceNum = props.invoiceNum
    const setInvoiceNum = props.setInvoiceNum

    const includeNoNB = props.includeNoNB
    const setIncludeNoNB = props.setIncludeNoNB
    const nonBillableValues = props.nonBillableValues

    const include = props.include
    const setInclude = props.setInclude
    const includeValues = props.includeValues

    const yesNoValues = props.yesNoValues
    const setAsInvoiced = props.setAsInvoiced
    const setSetAsInvoiced = props.setSetAsInvoiced
    const createCashFlow = props.createCashFlow
    const setCreateCashFlow = props.setCreateCashFlow

    const period = props.period
    const setPeriod = props.setPeriod
    const periodItems = props.periodItems


    console.log("include no nb", includeNoNB)

    // debugger

    return(
        <>

            <div className="invoice-dialog-textbox">
                <h2>Číslo Fa:</h2>
                <TextBox
                    value={invoiceNum}
                    onChange={(e) => setInvoiceNum(e.target.value)}
                />
            </div>

            <div className="invoice-dialog-textbox">
                <h2>Doplnit tagy:</h2>
                <TextBox
                    value={tags}
                    onChange={(e) => setTags(e.target.value)}
                />
            </div>

            <div className="invoice-dialog-textbox">
                <h2>Označit jako fakturované:</h2>
                <DropDownList
                    data={yesNoValues}
                    textField="text"
                    dataItemKey="id"
                    value={setAsInvoiced}
                    onChange={(e) => setSetAsInvoiced(e.value)}
                />
            </div>

            <div className="invoice-dialog-textbox">
                <h2>Vytvořit Cashflow:</h2>
                <DropDownList
                    data={yesNoValues}
                    textField="text"
                    dataItemKey="id"
                    value={createCashFlow}
                    onChange={(e) => setCreateCashFlow(e.value)}
                />
            </div>

            <br />

            <div className="invoice-dialog-textbox">
                <h2>Zahrnout:</h2>
                <DropDownList
                    data={includeValues}
                    textField="text"
                    dataItemKey="id"
                    value={include}
                    onChange={(e) => setInclude(e.value)}
                />
            </div>

            <div className="invoice-dialog-textbox">
                <h2>Non-billable:</h2>
                <DropDownList
                    data={nonBillableValues}
                    textField="text"
                    dataItemKey="id"
                    value={includeNoNB}
                    onChange={(e) => setIncludeNoNB(e.value)}
                />
            </div>

            <div className="invoice-dialog-textbox">
                <h2>Období:</h2>
                <DropDownList
                    // value={1}
                    data={periodItems}
                    textField="text"
                    dataItemKey="id"
                    value={period}
                    onChange={(e) => setPeriod(e.value)}
                />
            </div>



        </>
    )
}

export default InvoiceBasicParams